import React , { useEffect, useState }  from 'react';

import { Link } from 'react-router-dom';
import SingleCourseThree from '../../components/Course/SingleCourseThree';

import courses from '../../data/Courses.json';
import SectionTitle from '../../components/SectionTitle';
import SingleCourse from '../../components/Course/SingleCourse';
import CourseService from '../../services/course.service';
const CourseGridMain = () => {
    const [courseList,setCourseList]=useState([]);
    const [extra,setExtra]=useState({});
    const [query,setQuery]=useState({});

    // const getInitialStateCategory = () => {
    //     const category = "Marketing";
    //     return category;
    // };

    // const [category, setCategory] = useState(getInitialStateCategory);

    // const handleChangeCategory = (e) => {
    //     setCategory(e.target.value);
    // };

    // const getInitialStateLanguage = () => {
    //     const language = "English";
    //     return language;
    // };

    // const [language, setLanguage] = useState(getInitialStateLanguage);

    // const handleChangeLanguage = (e) => {
    //     setLanguage(e.target.value);
    // };

    // const getInitialStateSkill = () => {
    //     const skill = "Intermediate";
    //     return skill;
    // };

    // const [skill, setSkill] = useState(getInitialStateSkill);

    // const handleChangeSkill = (e) => {
    //     setSkill(e.target.value);
    // };


    // const handlePagination=async(page,type)=>{
    //     const query={};
    //     if(type==="next"){
    //         query.page= Number(extra.page)+1;
    //     }else if(type==="prev"){
    //         query.page= Number(extra.page)-1;
    //     }else{
    //         query.page=page
    //     }
    //     setQuery(query);
    // }

    useEffect(()=>{
        CourseService.list(query)
        .then(res=>{setCourseList(res?.data);setExtra(res?.extra)})
        .catch(err=>console.log(err))
    },[query]);

    console.log("extra",extra);

    return (
        <div className="react-course-filter back__course__page_grid pb---40 pt---110">
            <div className="container pb---70"> 
                {/* <div className="row align-items-center back-vertical-middle shorting__course mb-50">
                    <div className="col-md-2">
                        <div className="all__icons"> 
                            <div className="list__icons">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-sliders"><line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line></svg>
                            </div>
                            <div className="result-count">Filters</div>
                        </div>
                    </div>
                    <div className="col-md-10 text-right">
                        <select className="from-control category" onChange={handleChangeCategory}>
                            <option value="Marketing">All Categories</option>
                            <option value="Education">Education</option>
                            <option value="Marketing">Marketing</option>
                            <option value="Development">Development</option>
                            <option value="UI/UX Design">UI/UX Design</option>
                        </select>
                        <select className="from-control language" onChange={handleChangeLanguage}>
                            <option value="English">All Language</option>
                            <option value="English">English</option>
                            <option value="Italic">Italic</option>
                            <option value="Spanish">Spanish</option>
                            <option value="Bangla">Bangla</option>
                            <option value="Urdu">Urdu</option>
                            <option value="Hindi">Hindi</option>
                        </select>
                        <select className="from-control price">
                            <option>All Prices</option>
                            <option>Free Courses</option>
                            <option>Paid Courses</option>
                            <option>Subscribers Only</option>
                        </select>
                        <select className="from-control skill" onChange={handleChangeSkill}>
                            <option value="Intermediate">All Skills</option>
                            <option value="Beginner">Beginner</option>
                            <option value="Intermediate">Intermediate</option>
                            <option value="Expert">Advanced</option>
                        </select>
                    </div>
                </div>
                <div className="row align-items-center back-vertical-middle shorting__course2 mb-50">
                    <div className="col-md-6">
                        <div className="all__icons"> 
                            <div className="result-count">We found 104 courses available for you</div>
                        </div>
                    </div>
                    <div className="col-md-6 text-right">                                
                        <select className="from-control">
                            <option>Sort by: Default</option>
                            <option>Sort by popularity</option>
                            <option>Sort by average rating</option>
                            <option>Sort by lates</option>
                            <option>Sort by price: low to high</option>
                            <option>Sort by price: high to low</option>
                        </select>
                    </div>
                </div>                                                   */}
                {/* <div className="row"> 
                    {courses.filter(course => {
                        return course.name === category || course.language === language || course.type === skill;
                    }).map((data, index) => {
                        return (  
                            <div key={index} className="col-lg-4">
                            { 
                                <SingleCourseThree
                                    courseID={data.id}
                                    courseImg= {`${data.image}`}
                                    courseTitle= {data.title}
                                    courseName= {data.name}
                                    courseAuthor= {data.author}
                                    courseType= {data.type}
                                    courseLesson= {data.lesson}
                                    courseDuration= {data.duration}
                                    courseEnrolled= {data.enrolled}
                                    coursePrice= {data.price}
                                    courseReview= {data.review}
                                />
                            }
                            </div>
                        )
                    })}
                </div> */}
                  <div className="container">
                <SectionTitle Title="Our" subtitle="Courses" />
                <p>At Ocfit, we are committed to delivering high-quality education and vocational training that meets industry standards. We ensure our students acquire relevant skills for today’s job market. By forming partnerships with industry leaders, we provide valuable job opportunities and remain responsive to the evolving needs of individuals from remote areas, lower socio-economic backgrounds, and those with disabilities.</p>
                <h2>
                Diverse Educational and Vocational Programs
                </h2>
                <p>Ocfit offers a wide range of programs tailored to meet various needs and aspirations:</p>
                <div className="row">
                    {courseList?.map((data, index) => {
                        return (
                            <div key={index} className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 wow animate__fadeInUp mb-4" data-wow-duration="0.3s">
                                {
                                    <SingleCourse
                                        courseID={data?._id}
                                        courseImg= {`${data?.thumbnailImgUrl}`}
                                        courseTitle= {data?.title}
                                        // courseName= {data.name}
                                        // courseLesson= {data.lesson}
                                        // courseEnrolled= {data.enrolled}
                                        // coursePrice= {data.price}
                                        description={data?.shortDescription}
                                        slug={data?.slug}
                                        type={"course"}
                                    />
                                }

                            </div>
                        )
                    })}
                </div>
                {/* <ul className="back-pagination pt---20">
                <li className="back-next">
                    <button onClick={()=>handlePagination(undefined,"prev")}>
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5 12H19M5 12L11 6M5 12L11 18" stroke="#5B5F64" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg></button></li>
                    <li><button style={{background: "#3270FC", color: "#ffffff"}} onClick={()=>handlePagination(Number(extra.page))} >{extra.page}</button></li>
                    <li><button onClick={()=>handlePagination(Number(extra.page +1))} >{extra.page +1}</button></li>
                    <li className="back-next"><button onClick={()=>handlePagination(undefined,"next")}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></button></li>
                </ul> */}
            </div>
            </div>
        </div>
    );
}

export default CourseGridMain;  